import React from "react";
import styles from "../style.module.scss";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showApplyBundleReceiptBottomSheetAction } from "@src/components/BottomSheets/store/actions";

import DownloadIcon from "@src/components/AccentIcons/DownloadIcon";

const DownloadBundleReceipt = ({ data }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <div
      className={styles.DownloadReceipt}
      onClick={() => dispatch(showApplyBundleReceiptBottomSheetAction(true))}
    >
      {/* <div className={styles.DownloadReceipt} onClick={() => handleClick()}> */}
      <div className={styles.DownloadReceipt__Left}>
        <DownloadIcon />
      </div>
      <div className={styles.DownloadReceipt__Right}>
        {t(
          "components.tabs.overview.components.Pricing.downloadReceipt",
          "Download Receipt"
        )}
      </div>
    </div>
  );
};

export default DownloadBundleReceipt;
